export const convertDate = (
  date: Date | null,
  options?: Intl.DateTimeFormatOptions
) => {
  if (!date) {
    return null;
  }
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    ...options,
  });
};
